// extracted by mini-css-extract-plugin
export default {"reportFailure":"twFA2","emptyField":"jDD9G","formSection":"TKK4E","requiredLabel":"GEXWk","formActions":"Nx9ad","formBtn":"D5mg4","clockSelect":"cohw0","container":"TXV2h"};